<script>
import CustomIcon from 'dashboard/components/ui/CustomIcons.vue';

export default {
  name: 'CommentTypeBadge',
  components: {
    CustomIcon,
  },
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  computed: {
    data() {
      const commentTypes = {
        FEED: {
          label: 'Feed',
          textColor: '#60646C',
          bgColor: '#F5F5F5',
        },
        MENTION: {
          label: 'Menção',
          textColor: '#60646C',
          bgColor: '#F5F5F5',
        },
        AD: {
          label: 'Patrocinado',
          textColor: '#60646C',
          bgColor: '#F5F5F5',
        },
        REELS: {
          label: 'Reels',
          textColor: '#60646C',
          bgColor: '#F5F5F5',
        },
      };
      return (
        commentTypes[this.type] || {
          label: 'Desconhecido',
          textColor: '#000000',
          bgColor: '#FFFFFF',
        }
      );
    },
  },
};
</script>

<template>
  <div
    :class="`flex items-center justify-center gap-2 rounded-lg p-2 text-xs font-semibold bg-[${data.bgColor}] text-[${data.textColor}]`"
  >
    <CustomIcon group="commentType" :name="type" :color="data.textColor" />
    <span>{{ data.label }}</span>
  </div>
</template>
